$(document).ready(function () {
    $(".overlay-export-report-ti").hide()
    $("#report-ti-export").on('submit', function (e) {
        e.preventDefault()
        $(".overlay-export-report-ti").show()
        let data = new FormData(this)
        $.ajax({
            url: '/export-report-ti',
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            xhrFields: {
                responseType: 'blob',
            },
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (result, status, xhr) {

                setTimeout(function () {
                    downloadjs(xhr,result)
                    $(".overlay-export-report-ti").hide()
                }, 1000)
            }
        }).fail(function () {
            $(".overlay-export-report-ti").hide()
        })
    })

    function downloadjs(xhr,result) {
        var disposition = xhr.getResponseHeader('content-disposition');
        var matches = /"([^"]*)"/.exec(disposition);
        //var filename = (matches != null && matches[1] ? matches[1] : 'reporte_stock_' + getDate() + '.xlsx');
        var filename = (matches != null && matches[1] ? matches[1] : 'reporte_actividades.xlsx');

        // The actual download
        var blob = new Blob([result], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        alertWithBtn('La descarga ha finalizado.')
    }
})
